<pas-tabset [routerParam]="routerParamName" [paramMode]="'path'" (tabChange)="onChangingTab($event)">
  <pas-tab [id]="OVERVIEW_TAB">
    <ng-template pasTabTitle>
      <b>{{ 'AFTER_SALES_OVERVIEW_TAB' | translate }}</b>
    </ng-template>
    <ng-template pasTabContent>
      <app-after-sales></app-after-sales>
    </ng-template>
  </pas-tab>
  <pas-tab [id]="DETAILS_TAB" [disabled]="detailsTabDisabled" [hidden]="detailsTabHidden">
    <ng-template pasTabTitle>
      <b>{{ 'AFTER_SALES_DETAILS_TAB' | translate }}</b>
    </ng-template>
    <ng-template pasTabContent>
      <app-after-sales-details (signal)="onCancel()"></app-after-sales-details>
    </ng-template>
  </pas-tab>
  @if (errorCostRatesTabVisible()) {
    <pas-tab [id]="ERROR_COST_RATE_TAB">
      <ng-template pasTabTitle>
        <b>{{ 'AFTER_SALES_ERROR_COST_RATE_TAB' | translate }}</b>
      </ng-template>
      <ng-template pasTabContent>
        <app-after-sales-error-cost-rate (cancel)="onCancel()"></app-after-sales-error-cost-rate>
      </ng-template>
    </pas-tab>
  }
  <pas-tab [id]="SUPPLIER_EXCEPTIONS_TAB">
    <ng-template pasTabTitle>
      <b>{{ 'AFTER_SALES_SUPPLIER_EXCEPTIONS_TAB' | translate }}</b>
    </ng-template>
    <ng-template pasTabContent>
      <supplier-exceptions></supplier-exceptions>
    </ng-template>
  </pas-tab>
</pas-tabset>
